<template>
    <BarometerHero :title="title" :image-url="imageUrl" :cta="cta" :breadcrumbs="breadcrumbs" />
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation, useRoute} from '#imports';
    import {BAROMETER_JOB} from '~/keys';
    import BarometerHero from '../BarometerHero.vue';

    const {jobBarometer} = inject(BAROMETER_JOB)!;
    const {t} = useTranslation();
    const route = useRoute();

    const title = t('barometer.family.banner.title', [jobBarometer.jobLabelPlural]);
    const imageUrl = `https://dam.malt.com/families/banner/mobile-big/${jobBarometer.familyBannerName || 'default'}?w=500`;
    const cta = {url: '/who-are-you', label: t('barometer.banner.cta')};
    const breadcrumbs = [
        {url: `/`, label: t('barometer.breadcrumbs.home')},
        {url: `/t/${route.params.urlPrefix}`, label: t('barometer.breadcrumbs.general')},
        {label: jobBarometer.jobLabelPlural!},
    ];
</script>
